module.exports = __webpack_public_path__ + "media/order_create_1.ec4b8abf.mp3";